import { useQuery } from '@tanstack/react-query';
import { reportService } from '../api/services';

export const reportQueryKeys = {
  report: (id: string, beginDate: string, endDate: string) => ['report', id, beginDate, endDate] as const,
};

export const useReportQuery = (reportId: string, beginDate?: string, endDate?: string) => {
  return useQuery({
    queryKey: reportQueryKeys.report(reportId ?? '', beginDate ?? '', endDate ?? ''),
    queryFn: () => {
      if (!reportId) {
        throw new Error('Missing required parameters');
      }
      return reportService.getReport(reportId, beginDate, endDate);
    },
    enabled: Boolean(reportId)
  });
}; 